<div class="document-search-container">
  <rkt-table-search
    (changed)="onSearch($event)"
    placeholder="Search..."
    class="document-search"
    [disabled]="loading"
    autocomplete="off"
  ></rkt-table-search>
  <button class="add-scheduled-report" (click)="navigateToScheduledReport()" [disabled]="loading | accessControl | async">
    <rkt-icon name="schedule" class="rocket-icon"></rkt-icon>
    <span>Schedule</span>
  </button>
</div>

<div class="document-list">
  <div class="report-form-container">
    <rkt-form [form]="reportFilterForm" [fields]="formFields" [model]="formModel" (modelChange)="onModelChange()"></rkt-form>
  </div>

  @if (filteredReports?.length) {
    @for (documentList of filteredReports; track documentList) {
      <div>
        <app-report-list-item [documentListItem]="documentList"></app-report-list-item>
      </div>
    }
    <app-pagination [totalPages]="totalPages" [activePage]="activePage" (updatePageParam)="getInsightReports($event)"></app-pagination>
  } @else {
    @if (!loading) {
      <div class="empty-state">
        <div class="image"></div>
        <div class="message">No Report Available</div>
      </div>
    }
    @if (loading) {
      @for (i of [].constructor(7); track i) {
        <div class="document-list-item"></div>
      }
    }
  }
</div>
